<div class="main" [ngStyle]="{'overflow': openMusicAddForm ? 'hidden' : ''}">
    <div class="dashboard-header">
        <img src="../../assets/1.png" alt="Logo" style="width: 150px;margin:6px;">
    </div>

    <div class="navbar" style="justify-content: space-between;">
        <span class="wrap-header">
            <span *ngIf="showUserManagementDropdown()" class="nav-item" style="font-size: 15px;">
                <a> Content Configuration <span style="position: relative;top: .1em;font-size: 15px;">▼</span></a>
                <div class="dropdown" style="margin-top: 10px;">
                    <a *ngIf="showUserDropdown()" (click)="openPublisher(); this.searchTerm = ''; this.pageSize = 10;">
                        Publishers</a>
                    <a *ngIf="showUserDropdown()" (click)="opeTags(); this.searchTerm = '';this.pageSize = 10;">
                        Tags</a>
                    <a *ngIf="showUserDropdown()" (click)="openDeployments(); this.searchTerm = ''"> Deployments</a>
                    <a *ngIf="showUserDropdown()" (click)="openArtist(); this.searchTerm = '';this.pageSize = 10;">
                        Artists</a>
                    <a *ngIf="showUserDropdown()" (click)="openGeneres(); this.searchTerm = '';this.pageSize = 10;">
                        Genres</a>
                </div>
            </span>
            <span class="nav-item" style="font-size: 15px;margin-left: -10px;">
                <a> Content Management <span style="position: relative;top: .1em;font-size: 15px;">▼</span></a>
                <div class="dropdown" style="margin-left: 10px;margin-top: 10px;">
                    <a (click)="openMuisc(); this.searchTerm = '';this.pageSize = 10;"> Music List</a>
                    <a  *ngIf="showNametune()" (click)="openNamertune(); this.searchTerm = '';this.pageSize = 10;"> NameTune </a>
                </div>
            </span>
            <span *ngIf="showUserManagementDropdown()" class="nav-item" style="font-size: 15px;margin-left: -10px;">
                <a> User Management <span style="position: relative;top: .1em;font-size: 15px;">▼</span></a>
                <div class="dropdown" style="margin-top: 10px;">
                    <a *ngIf="showUserDropdown()"
                        (click)="opeUsers(); this.searchTerm = '';this.pageSize = 10;">Users</a>
                    <a *ngIf="showRoleDropdown()"
                        (click)="opeRoles(); this.searchTerm = '';this.pageSize = 10;">Roles</a>
                </div>
            </span>
        </span>
        <div class="nav-item" style="font-size: 15px;">
            <span style="color: black;">Welcome : {{userName ? userName : 'User'}}</span><a><i
                    class="fas fa-user"></i></a>
            <div class="dropdown">
                <a (click)="openAddForm(addChangePasswordModal); this.passwordForm.reset();this.showConfirmPassword = false;
                this.showNewPassword = false;
                this.showCurrentPassword = false;"> Change Password</a>
                <a (click)="openAddForm(openLogOutModel)"> Logout</a>
            </div>
        </div>
    </div>

    <ng-container *ngIf="publisher">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px;">
            <i class="fas fa-home"></i> {{'/'}} Content Configuration {{'/'}} Publishers {{'/'}} View
        </span>
        <div class="table-container">
            <div class="table-header">
                <button class="btn-create" style="font-size: 15px; font-weight: 600;">
                    <span style="cursor:pointer !important"
                        (click)="openAddForm(addPublisherModal); this.publisherForm.reset()">
                        <i class="fas fa-plus" style="margin-right: 5px;"></i>
                        <span>Create Publisher</span>
                    </span>
                </button>
            </div>
            <div class="table-controls">
                <span style="margin-top:-5px;">
                    <label for="entries" style="font-size: 15px;">Show</label>
                    <select style="font-size: 15px;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Publisher')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Publisher')"
                            (keypress)="preventSpace($event)" (blur)="validateInput()"
                            placeholder="Search for publisher..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>
            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No</th>
                        <th style="text-align: center;" (click)="sortData('publisherName', 'Publisher')">Publisher Name
                            <span style="float: right;" *ngIf="sortColumn === 'publisherName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('email', 'Publisher')">Email
                            <span style="float: right;" *ngIf="sortColumn === 'email'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('pubslisherStatus', 'Publisher')">Status
                            <span style="float: right;" *ngIf="sortColumn === 'pubslisherStatus'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="publisherArray?.length === 0; else publisherList">
                        <td colspan="14" class="no-data">
                            <span>No results found</span>
                        </td>
                    </tr>
                    <ng-template #publisherList>
                        <tr *ngFor="let publisher of publisherArray ; let i = index">
                            <td style="font-size: 15px; text-align: center;">
                                {{ (currentPage - 1) * pageSize + i + 1 }}
                            </td>
                            <td style="font-size: 15px;text-align: center;width: 15%;word-break: break-all;">
                                {{ publisher.publisherName }}
                            </td>
                            <td style="font-size: 15px; text-align: center;">
                                {{ publisher.email }}
                            </td>
                            <td style="font-size: 15px; text-align: center;">
                                <span style="margin-right: 20px;">{{ publisher.publisherStatus ?
                                    publisher.publisherStatus : '' }}</span>
                                <span>
                                    <label class="switch">
                                        <input type="checkbox" [checked]="publisher.publisherStatus === 'Active'"
                                            (change)="onStatusChange($event, publisher)">
                                        <span class="slider"></span>
                                    </label>
                                </span>
                            </td>
                            <td style="font-size: 15px; text-align: center;">
                                <span (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Publisher')"
                                    class="action-text delete">
                                    <i class="fa fa-close"></i> Delete
                                </span>
                                <span (click)="openAddForm(addPublisherModal); EditTag(publisher, 'Publisher')"
                                    class="action-text edit">
                                    <i class="fas fa-pen"></i> Edit
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <button style="margin-right: 10px; font-size: 15px;background-color: white;"
                        (click)="previousPage(publisherArray, 'Publisher')" [disabled]="currentPage === 1">
                        Previous
                    </button>
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,publisherArray, 'Publisher')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>
                    <button style="margin-left: 10px; margin-right: 10px; font-size: 15px; background-color: white;"
                        (click)="nextPage(publisherArray, 'Publisher')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
        <ng-template #addPublisherModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Publisher</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="publisherForm" (ngSubmit)="onAddPublisher()" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="publisherName" class="form-label" style="margin-bottom: 7px;">Publisher Name<span
                                style="color: red;margin-left:5px;">*</span></label>
                        <input (keypress)="preventSpace($event)" maxlength="50" type="text" class="form-control"
                            id="publisherName" formControlName="publisherName" placeholder="Enter Valid Name"
                            required />
                        <div *ngIf="publisherForm.get('publisherName')?.touched" style="color: red;margin-left:5px;">
                            <span *ngIf="publisherForm.get('publisherName')?.hasError('required')">
                                Publisher Name is required.
                            </span>
                            <span *ngIf="!publisherForm.get('publisherName')?.hasError('required') 
                                             && publisherForm.get('publisherName')?.hasError('invalidCharacters')">
                                Publisher Name should not contain emojis or special characters.
                            </span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="contactPersonName" class="form-label" style="margin-bottom: 7px;">Contact Person
                            Name<span style="color: red;margin-left:5px;">*</span></label>
                        <input (keypress)="preventSpace($event)" maxlength="50" type="text" class="form-control"
                            id="contactPersonName" formControlName="contactPersonName" placeholder="Enter Valid Name"
                            required />
                        <div *ngIf="publisherForm.get('contactPersonName')?.touched && publisherForm.get('contactPersonName')?.invalid"
                            style="color: red;margin-left:5px;">
                            Contact Person Name is required.
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="email" class="form-label" style="margin-bottom: 7px;">Email<span
                                style="color: red;margin-left:5px;">*</span></label>
                        <input (keypress)="preventSpace($event)" type="email" class="form-control" id="email"
                            formControlName="email" placeholder="Enter Email" required />
                        <div *ngIf="publisherForm.get('email')?.touched && publisherForm.get('email')?.invalid"
                            style="color: red;margin-left:5px;">
                            <span *ngIf="publisherForm.get('email')?.hasError('required')">Email is required.</span>
                            <span *ngIf="publisherForm.get('email')?.hasError('pattern')">Enter a valid email.</span>
                        </div>
                    </div>
                    <!-- <div class="mb-3" id="input-wrapper">
                        <label for="contactNumber" class="form-label" style="margin-bottom: 7px;">Contact Number<span
                                style="color: red;margin-left:5px;">*</span></label>
                        <span for="number">+263</span>
                        <input onchange="this.value = '+44' + this.value" (keypress)="allowOnlyNumbers($event)" maxlength="10" minlength="10" type="text"
                            class="form-control" id="contactNumber" formControlName="contactNumber"
                            placeholder="Enter Contact Number" />
                        <div *ngIf="publisherForm.get('contactNumber')?.touched && publisherForm.get('contactNumber')?.invalid"
                            style="color: red;margin-left:5px;">
                            <span *ngIf="publisherForm.get('contactNumber')?.hasError('required')">Contact Number is
                                required.</span>
                            <span *ngIf="publisherForm.get('contactNumber')?.hasError('pattern')">Enter a valid contact
                                number.</span>
                        </div>
                    </div> -->
                    <div class="mb-3" id="input-wrapper">
                        <label for="contactNumber" style="margin-bottom: 7px;" class="form-label">
                            Contact Number <span style="color: red; margin-left: 5px;">*</span>
                        </label>

                        <div class="contact-input">
                            <span class="country-code">+263</span>
                            <input id="contactNumber" class="form-control contact-number"
                                formControlName="contactNumber" (keypress)="allowOnlyNumbers($event)" maxlength="9"
                                minlength="9" type="text" formControlName="contactNumber"
                                placeholder="Enter Contact Number">
                        </div>
                        <div *ngIf="publisherForm.get('contactNumber')?.touched && publisherForm.get('contactNumber')?.invalid"
                            style="color: red;margin-left:5px;">
                            <span *ngIf="publisherForm.get('contactNumber')?.hasError('required')">Contact Number is
                                required.</span>
                            <span *ngIf="publisherForm.get('contactNumber')?.hasError('pattern')">Enter a valid contact
                                number.</span>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary custom-btn-add" style="margin-right: 10px;"
                    (click)="onAddPublisher()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}} Publisher
                </button>
                <button type="button" class="btn btn-secondary custom-btn-cancel"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>
    </ng-container>

    <ng-container *ngIf="Artist">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px;">
            <i class="fas fa-home"></i> {{'/'}} Content Configuration {{'/'}} Artists {{'/'}} View
        </span>

        <div class="table-container">
            <div class="table-header">
                <button class="btn-create" style="font-size: 15px; font-weight: 600;">
                    <span style="cursor:pointer !important"
                        (click)="openAddForm(addArtistModal); this.selectedImage = null; this.artistForm.reset();">
                        <i class="fas fa-plus" style="margin-right: 5px;"></i>
                        <span>Create Artist</span>
                    </span>
                </button>
            </div>

            <div class="table-controls">
                <span style="margin-top:-5px;">
                    <label for="entries" style="font-size: 15px;">Show</label>
                    <select style="font-size: 15px;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Artist')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Artist')"
                            (keypress)="preventSpace($event)" (blur)="validateInput()"
                            placeholder="Search for artist..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No</th>
                        <th style="text-align: center;">Image</th>
                        <th style="text-align: center;" (click)="sortData('artistName', 'Artists')">Artist Name
                            <span style="float: right;" *ngIf="sortColumn === 'artistName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="artistArray?.length === 0; else artistList">
                        <td colspan="14" class="no-data">
                            <span>No results found</span>
                        </td>
                    </tr>
                    <ng-template #artistList>
                        <tr *ngFor="let artist of artistArray ; let i = index">
                            <td style="font-size: 15px; text-align: center;">{{ (currentPage - 1) * pageSize + i + 1 }}
                            </td>
                            <td style="font-size: 15px;text-align: center;">
                                <img style="height: 40px;width: 40px;border-radius: 50%;"
                                    [src]="'https://' + artist.artistImageUrl" alt="Artist Image">
                            </td>
                            <td style="font-size: 15px;text-align: center;word-break: break-all;max-width: 100px;">
                                {{ artist.artistName }}
                            </td>
                            <td style="font-size: 15px; text-align: center;">
                                <span (click)="openAddForm(addDeleteModal); deleteModel(artist, 'Artist')"
                                    class="action-text delete">
                                    <i class="fa fa-close"></i> Delete
                                </span>
                                <span (click)="openAddForm(addArtistModal); EditTag(artist, 'Artist')"
                                    class="action-text edit">
                                    <i class="fas fa-pen"></i> Edit
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>
                <span>
                    <button style="margin-right: 10px; font-size: 15px;background-color: white;"
                        (click)="previousPage(artistArray, 'Artist')" [disabled]="currentPage === 1">
                        Previous
                    </button>
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page, artistArray, 'Artist')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>
                    <button style="margin-left: 10px; margin-right: 10px; font-size: 15px; background-color: white;"
                        (click)="nextPage(artistArray, 'Artist')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
        <ng-template #addArtistModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Artist</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="artistForm" (ngSubmit)="onAddArtist()" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="artistName" class="form-label" style="margin-bottom: 7px;">Artist Name
                            <span style="color: red;margin-left:5px">*</span>
                        </label>
                        <input (keypress)="preventSpace($event)" maxlength="50" type="text" class="form-control"
                            id="artistName" placeholder="Enter Valid Name" formControlName="artistName" />
                        <div *ngIf="artistForm.get('artistName')?.touched && artistForm.get('artistName')?.invalid">
                            <span style="color: red;margin-left:5px;"
                                *ngIf="artistForm.get('artistName')?.hasError('required')">
                                Artist Name is required.
                            </span>
                            <span style="color: red;margin-left:5px;" *ngIf="!artistForm.get('artistName')?.hasError('required') && 
                                         artistForm.get('artistName')?.hasError('invalidCharacters')">
                                Artist Name should not contain emojis or special characters.
                            </span>
                        </div>

                    </div>
                    <div class="mb-3">
                        <label for="artistImage" class="form-label" style="margin-bottom: 7px;">Artist Image <span
                                style="color: red;margin-left:5px">*</span></label>
                        <input style="margin-left: 0px !important;" type="file" class="form-control" id="artistImage"
                            (change)="onFileSelected($event)" />
                        <div *ngIf="selectedImage" style="margin-top: 10px;">
                            <img [src]="selectedImage" alt="Selected Artist"
                                style="max-width: 100px; max-height: 100px; border: 1px solid #ccc;" />
                        </div>
                    </div>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary custom-btn-add" style="margin-right: 10px;"
                    (click)="onAddArtist()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}} Artist
                </button>
                <button type="button" class="btn btn-secondary custom-btn-cancel"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>

        </ng-template>

    </ng-container>

    <ng-container *ngIf="user">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px;">
            <i class="fas fa-home"></i> {{'/'}} User Management {{'/'}} Users {{'/'}} View
        </span>

        <div class="table-container">
            <div class="table-header">
                <button class="btn-create" style="font-size: 15px; font-weight: 600;">
                    <span style="cursor:pointer !important"
                        (click)="openAddForm(addUserModal); this.userForm.reset();this.isPasswordVisible = false;">
                        <i class="fas fa-plus" style="margin-right: 5px;"></i>
                        <span>Create User</span>
                    </span>
                </button>
            </div>

            <div class="table-controls">
                <span style="margin-top:-5px">
                    <label for="entries" style="font-size: 15px;">Show</label>
                    <select style="font-size: 15px;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'User')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('User')"
                            (keypress)="preventSpace($event)" (blur)="validateInput()" placeholder="Search for user..."
                            class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No</th>
                        <th style="text-align: center;" (click)="sortData('username', 'User')">Name
                            <span style="float: right;" *ngIf="sortColumn === 'username'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('email', 'User')">Email Id
                            <span style="float: right;" *ngIf="sortColumn === 'email'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('contact', 'User')">Contact Number
                            <span style="float: right;" *ngIf="sortColumn === 'contact'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('roles', 'User')">Role
                            <span style="float: right;" *ngIf="sortColumn === 'roles'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Check if the user list is empty -->
                    <tr *ngIf="userArray?.length === 0; else userList">
                        <td colspan="6" class="no-data">
                            <span>No results found</span>
                        </td>
                    </tr>

                    <!-- ng-template for displaying the user list -->
                    <ng-template #userList>
                        <tr *ngFor="let user of userArray; let i = index">
                            <td style="font-size: 15px; text-align: center;">{{ (currentPage - 1) * pageSize + i + 1 }}
                            </td>
                            <td style="font-size: 15px; text-align: center;">{{ user.username }}</td>
                            <td style="font-size: 15px; text-align: center;">{{ user.email }}</td>
                            <td style="font-size: 15px; text-align: center;">{{ user.contact }}</td>
                            <td style="font-size: 15px; text-align: center;">{{ user.roles.join(', ') }}</td>
                            <td style="font-size: 15px; text-align: center;">
                                <span (click)="openAddForm(addDeleteModal); deleteModel(user, 'User')"
                                    class="action-text delete">
                                    <i class="fa fa-close"></i> Delete
                                </span>
                                <span
                                    (click)="openAddForm(addUserModal); EditTag(user, 'User'); this.isPasswordVisible = false;"
                                    class="action-text edit">
                                    <i class="fas fa-pen"></i> Edit
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px;background-color: white;"
                        (click)="previousPage(userArray, 'User')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,userArray, 'User')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button style="margin-left: 10px; margin-right: 10px; font-size: 15px; background-color: white;"
                        (click)="nextPage(userArray,'User')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
        <ng-template #addUserModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} User</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="userForm" (ngSubmit)="onAddUser()" style="padding: 20px;">
                    <!-- Username Field -->
                    <div class="mb-3">
                        <label for="username" class="form-label" style="margin-bottom: 7px;">User Name <span
                                style="color: red;margin-left:5px">*</span></label>
                        <input (keypress)="preventSpace($event)" maxlength="50" style="width: 460px;" autocomplete="off"
                            type="text" class="form-control" id="username" formControlName="username"
                            placeholder="Enter Username" />
                        <div *ngIf="userForm.get('username')?.touched && userForm.get('username')?.invalid"
                            style="color: red;margin-left:5px;">
                            <span *ngIf="userForm.get('username')?.hasError('required')">
                                Username is required.
                            </span>
                            <span
                                *ngIf="!userForm.get('username')?.hasError('required') && userForm.get('username')?.hasError('invalidCharacters')">
                                Username should not contain emojis or special characters.
                            </span>
                        </div>

                    </div>

                    <!-- Email Field -->
                    <div class="mb-3">
                        <label for="email" class="form-label" style="margin-bottom: 7px;">
                            Email <span style="color: red;">*</span>
                        </label>
                        <input (keypress)="preventSpace($event)" style="width: 460px;" type="email" class="form-control"
                            id="email" formControlName="email" placeholder="Enter Email" />
                        <div *ngIf="userForm.get('email')?.touched && userForm.get('email')?.invalid"
                            style="color: red;margin-left:5px;">
                            <span *ngIf="userForm.get('email')?.hasError('required')">Email is required.</span>
                            <span *ngIf="userForm.get('email')?.hasError('pattern')">Enter a valid email.</span>
                        </div>
                    </div>
                    <!-- Contact Number Field -->
                    <!-- <div class="mb-3">
                        <label for="contactNumber" style="margin-bottom: 7px;" class="form-label">
                            Contact Number <span style="color: red;">*</span>
                        </label>
                        <input maxlength="10" minlength="10" style="width: 460px;" type="text" class="form-control"
                            id="contactNumber" formControlName="contactNumber" placeholder="Enter Contact Number"
                            (keypress)="allowOnlyNumbers($event)" />
                        <div *ngIf="userForm.get('contactNumber')?.touched && userForm.get('contactNumber')?.invalid"
                            style="color: red;margin-left:5px;">
                            <span *ngIf="userForm.get('contactNumber')?.hasError('required')">Contact number is
                                required.</span>
                            <span *ngIf="userForm.get('contactNumber')?.hasError('pattern')">Enter a valid 10-digit
                                number.</span>
                        </div>
                    </div> -->

                    <div class="mb-3" id="input-wrapper">
                        <label for="contactNumber" style="margin-bottom: 7px;" class="form-label">
                            Contact Number <span style="color: red; margin-left: 5px;">*</span>
                        </label>

                        <div class="contact-input">
                            <span class="country-code">+263</span>
                            <input id="contactNumber" class="form-control contact-number"
                                formControlName="contactNumber" (keypress)="allowOnlyNumbers($event)" maxlength="9"
                                minlength="9" type="text" formControlName="contactNumber"
                                placeholder="Enter Contact Number">
                        </div>
                        <div *ngIf="userForm.get('contactNumber')?.touched && userForm.get('contactNumber')?.invalid"
                            style="color: red;margin-left:5px;">
                            <span *ngIf="userForm.get('contactNumber')?.hasError('required')">Contact Number is
                                required.</span>
                            <span *ngIf="userForm.get('contactNumber')?.hasError('pattern')">Enter a valid contact
                                number.</span>
                        </div>
                    </div>
                    <!-- Password Field -->
                    <div class="mb-3">
                        <label for="password" style="margin-bottom: 7px;" class="form-label">Password <span
                                style="color: red;">*</span></label>
                        <div class="input-group" style="position: relative;">
                            <input (keypress)="preventSpace($event)" maxlength="20" style="width: 460px;"
                                [type]="isPasswordVisible ? 'text' : 'password'" class="form-control" id="password"
                                formControlName="password" placeholder="Enter Password" autocomplete="new-password" />
                            <i class="fa" [ngClass]="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'"
                                style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;"
                                (click)="togglePasswordVisibility()"></i>
                        </div>
                        <div *ngIf="userForm.get('password')?.touched && userForm.get('password')?.invalid"
                            style="color: red; margin-left: 5px;">
                            <span *ngIf="userForm.get('password')?.hasError('required')">
                                New password is required.
                            </span>
                            <span
                                *ngIf="!userForm.get('password')?.hasError('required') && userForm.get('password')?.hasError('minlength')">
                                Password must be at least 6 characters long.
                            </span>
                            <span *ngIf="!userForm.get('password')?.hasError('required') && 
                                          !userForm.get('password')?.hasError('minlength') && 
                                          userForm.get('password')?.hasError('maxlength')">
                                Password must be no more than 20 characters long.
                            </span>
                            <span *ngIf="!userForm.get('password')?.hasError('required') && 
                                          !userForm.get('password')?.hasError('minlength') && 
                                          !userForm.get('password')?.hasError('maxlength') && 
                                          userForm.get('password')?.hasError('passwordStrength')">
                                Password must contain at least one special character, one digit, and one uppercase
                                letter.
                            </span>
                        </div>
                    </div>

                    <!-- Role Dropdown -->
                    <div class="mb-3" style="margin-top: -15px;">
                        <label for="role" style="margin-bottom: 7px;" class="form-label">Role <span
                                style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown style="width: 460px;" class="form-select music"
                            [placeholder]="'Select Role'" [settings]="dropdownSettings" [data]="roleArray"
                            formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="userForm.get('role')?.touched && userForm.get('role')?.invalid"
                            style="color: red;margin-left:5px;">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary custom-btn-add" style="margin-right: 10px;"
                    (click)="onAddUser()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}} User
                </button>
                <button type="button" class="btn btn-secondary custom-btn-cancel"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>


    </ng-container>

    <ng-container *ngIf="role">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px;">
            <i class="fas fa-home"></i> {{'/'}} User Management{{'/'}} Roles {{'/'}} View
        </span>

        <div class="table-container">
            <!-- <div class="table-header">
                <button (click)="openAddForm(addArtistModal)" class="btn-create"
                    style="font-size: 15px;font-weight: 600;">
                    <i class="fas fa-plus"></i> Create Artist
                </button>
            </div> -->

            <div class="table-controls" style="padding: 20px;padding-bottom: 0;">
                <span style="margin-top: -20px;">
                    <label for="entries" style="font-size: 15px;">Show</label>
                    <select style="font-size: 15px;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Role')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px;">entries</span>
                </span>

                <div class="search-container" style="margin-bottom: -10px;">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Role')"
                            (keypress)="preventSpace($event)" (blur)="validateInput()" placeholder="Search for role..."
                            class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>
            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'id'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;" (click)="sortData('role', 'Role')">Role Name
                            <span style="float: right;" *ngIf="sortColumn === 'role'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Check if the role array is empty -->
                    <tr *ngIf="roleArray?.length === 0; else roleList">
                        <td colspan="14" class="no-data">
                            <span>No results found</span>
                        </td>
                    </tr>

                    <!-- ng-template for displaying the role list -->
                    <ng-template #roleList>
                        <tr *ngFor="let role of roleArray; let i = index">
                            <td style="font-size: 15px; text-align: center;">{{ (currentPage - 1) * pageSize + i + 1 }}
                            </td>
                            <td style="font-size: 15px; text-align: center;">{{ role.role }}</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>


            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px;background-color: white;"
                        (click)="previousPage(roleArray,'Role')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,roleArray, 'Role')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button style="margin-left: 10px; margin-right: 10px; font-size: 15px; background-color: white;"
                        (click)="nextPage(roleArray,'Role')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>

        </div>
        <ng-template #addRoleModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Role</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form -->
                <form [formGroup]="roleForm" (ngSubmit)="onAddRole();" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="role" class="form-label">Role <span style="color: red;">*</span></label>
                        <!-- <select class="form-select" id="role" formControlName="role">
                            <option value="" disabled selected>Select Role</option>
                            <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                        </select> -->
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Role'"
                            [settings]="dropdownSettings" [data]="roleArray" formControlName="role">
                        </ng-multiselect-dropdown>
                        <div *ngIf="roleForm.get('role')?.touched && roleForm.get('role')?.invalid"
                            style="color: red;margin-left:5px;">
                            Role is required.
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary custom-btn-add" style="margin-right: 10px;"
                    (click)="onAddRole()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}} Role
                </button>
                <button type="button" class="btn btn-secondary custom-btn-cancel"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>

        </ng-template>

    </ng-container>

    <ng-container *ngIf="Generes">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px;">
            <i class="fas fa-home"></i> {{'/'}} Content Configuration {{'/'}} Genres {{'/'}} View
        </span>

        <div class="table-container">
            <div class="table-header">
                <button class="btn-create" style="font-size: 15px; font-weight: 600;">
                    <span style="cursor:pointer !important"
                        (click)="openAddForm(addGenreModal);this.selectedenereImage = null; this.genreForm.reset();">
                        <i class="fas fa-plus" style="margin-right: 5px;"></i>
                        <span>Create Genre</span>
                    </span>
                </button>
            </div>

            <div class="table-controls">
                <span style="margin-top:-5px;">
                    <label for="entries" style="font-size: 15px;">Show</label>
                    <select style="font-size: 15px;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Genre')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Genre')"
                            (keypress)="preventSpace($event)" (blur)="validateInput()" placeholder="Search for genre..."
                            class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'id'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;">Image
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'categoryImageUrl'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;" (click)="sortData('categoryName', 'Genres')">Genre Name
                            <span style="float: right;" *ngIf="sortColumn === 'categoryName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- No results found -->
                    <ng-template #noResultsTemplate>
                        <tr>
                            <td colspan="14" class="no-data">
                                <span> No results found</span>
                            </td>
                        </tr>
                    </ng-template>

                    <!-- Check if the filtered tags list is empty -->
                    <ng-container *ngIf="genreArray?.length === 0; else dataTemplate">
                        <ng-container *ngTemplateOutlet="noResultsTemplate"></ng-container>
                    </ng-container>

                    <!-- Data rows -->
                    <ng-template #dataTemplate>
                        <tr *ngFor="let publisher of genreArray; let i = index">
                            <td style="font-size: 15px; text-align: center;">{{ (currentPage - 1) * pageSize + i + 1 }}
                            </td>
                            <td style="font-size: 15px;text-align: center;">
                                <img style="height: 40px;width: 40px;border-radius: 50%;"
                                    [src]="'https://' + publisher.categoryImageUrl" alt="">
                            </td>
                            <td style="font-size: 15px;text-align: center;word-break: break-all;max-width: 100px;">
                                {{ publisher.categoryName }}
                            </td>
                            <td style="font-size: 15px; text-align: center;">
                                <span (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Genres')"
                                    class="action-text delete">
                                    <i class="fa fa-close"></i> Delete
                                </span>
                                <span (click)="openAddForm(addGenreModal); EditTag(publisher, 'Genres')"
                                    class="action-text edit">
                                    <i class="fas fa-pen"></i> Edit
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px;background-color: white;"
                        (click)="previousPage(genreArray, 'Genre')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,genreArray, 'Genre')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button style="margin-left: 10px; margin-right: 10px; font-size: 15px; background-color: white;"
                        (click)="nextPage(genreArray, 'Genre')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
        <ng-template #addGenreModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Genres</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <!-- Reactive Form for Genres -->
                <form [formGroup]="genreForm" (ngSubmit)="onAddGenre()" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="genreName" class="form-label" style="margin-bottom: 7px;">Genres Name
                            <span style="color: red;margin-left:5px">*</span>
                        </label>
                        <input (keypress)="preventSpace($event)" maxlength="50" type="text" class="form-control"
                            id="genreName" placeholder="Enter Valid Name" formControlName="genreName" />
                        <!-- Validation Error Message -->
                        <div *ngIf="genreForm.get('genreName')?.touched && genreForm.get('genreName')?.invalid">
                            <span style="color: red;margin-left:5px;"
                                *ngIf="genreForm.get('genreName')?.hasError('required')">
                                Genre Name is required.
                            </span>
                            <span style="color: red;margin-left:5px;" *ngIf="!genreForm.get('genreName')?.hasError('required') && 
                                         genreForm.get('genreName')?.hasError('invalidCharacters')">
                                Genre Name should not contain emojis or special characters.
                            </span>
                        </div>

                    </div>
                    <div class="mb-3">
                        <label for="genreImage" class="form-label" style="margin-bottom: 7px;">Genre Image <span
                                style="color: red;margin-left:5px">*</span></label>
                        <input style="margin-left: 0px !important;" type="file" class="form-control" id="genreImage"
                            (change)="onGenreFileSelected($event)" />
                        <!-- Preview -->
                        <div *ngIf="selectedenereImage" style="margin-top: 10px;">
                            <!-- <p>Selected Image:</p> -->
                            <img [src]="selectedenereImage" alt="Selected Artist"
                                style="max-width: 100px; max-height: 100px; border: 1px solid #ccc;" />
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary custom-btn-add" style="margin-right: 10px;"
                    (click)="onAddGenre()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}} Genre
                </button>
                <button type="button" class="btn btn-secondary custom-btn-cancel"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>

        </ng-template>

    </ng-container>

    <ng-container *ngIf="tags">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px;">
            <i class="fas fa-home"></i> {{'/'}} Content Configuration {{'/'}} Tags {{'/'}} View
        </span>

        <div class="table-container">
            <div class="table-header">
                <button class="btn-create" style="font-size: 15px; font-weight: 600;">
                    <span style="cursor:pointer !important" (click)="openAddForm(addTagModal);this.tagForm.reset();">
                        <i class="fas fa-plus" style="margin-right: 5px;"></i>
                        <span>Create Tag</span>
                    </span>
                </button>
            </div>

            <div class="table-controls">
                <span style="margin-top:-5px;">
                    <label for="entries" style="font-size: 15px;">Show</label>
                    <select style="font-size: 15px;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Tag')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Tag')"
                            (keypress)="preventSpace($event)" (blur)="validateInput()" placeholder="Search for tag..."
                            class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'id'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;" (click)="sortData('tagName', 'Tags')">Tag
                            <span style="float: right;" *ngIf="sortColumn === 'tagName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('contentType', 'Tags')">Content Type
                            <span style="float: right;" *ngIf="sortColumn === 'contentType'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- No results found -->
                    <ng-template #noResultsTemplate>
                        <tr>
                            <td colspan="14" class="no-data">
                                <span>No results found</span>
                            </td>
                        </tr>
                    </ng-template>

                    <!-- Check if the filtered tags list is empty -->
                    <ng-container *ngIf="tagsArray?.length === 0; else dataTemplate">
                        <ng-container *ngTemplateOutlet="noResultsTemplate"></ng-container>
                    </ng-container>

                    <!-- Data rows -->
                    <ng-template #dataTemplate>
                        <tr *ngFor="let publisher of tagsArray; let i = index">
                            <td style="font-size: 15px; text-align: center;">
                                {{ (currentPage - 1) * pageSize + i + 1 }}
                            </td>
                            <td style="font-size: 15px; text-align: center;word-break: break-all;max-width: 100px;">
                                {{ publisher.tagName }}
                            </td>
                            <td style="font-size: 15px; text-align: center;">
                                {{ publisher.contentType }}
                            </td>
                            <td style="font-size: 15px; text-align: center;">
                                <span (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Tag')"
                                    class="action-text delete">
                                    <i class="fa fa-close"></i> Delete
                                </span>
                                <span (click)="openAddForm(addTagModal); EditTag(publisher, 'Tag')"
                                    class="action-text edit">
                                    <i class="fas fa-pen"></i> Edit
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>


            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px;background-color: white;"
                        (click)="previousPage(tagsArray,'Tag')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,tagsArray, 'Tag')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button style="margin-left: 10px; margin-right: 10px; font-size: 15px; background-color: white;"
                        (click)="nextPage(tagsArray, 'Tag')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
        <ng-template #addTagModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Tag</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="tagForm" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="tagName" class="form-label" style="margin-bottom: 7px;">
                            Tag Name<span style="color: red;"> *</span>
                        </label>
                        <input (keypress)="preventSpace($event)" type="text" class="form-control" id="tagName"
                            maxlength="30" minlength="2" placeholder="Enter Valid Name" formControlName="tagName" />
                        <div *ngIf="tagForm.get('tagName')?.invalid && tagForm.get('tagName')?.touched"
                            style="color: red;margin-left:5px;">
                            <span *ngIf="tagForm.get('tagName')?.hasError('required')">Tag Name is required</span>
                            <span
                                *ngIf="!tagForm.get('tagName')?.hasError('required') && tagForm.get('tagName')?.hasError('invalidCharacters')">
                                Tag Name should not contain emojis or special characters
                            </span>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="contentType" class="form-label" style="margin-bottom: 7px;">
                            Content Type<span style="color: red;"> *</span>
                        </label>
                        <ng-select style="width: 445px;" class="form-select" [items]="['Music']" bindLabel="name"
                            bindValue="value" formControlName="contentType" placeholder="Select Content Type"
                            [searchable]="false">
                        </ng-select>
                        <div *ngIf="tagForm.get('contentType')?.invalid && tagForm.get('contentType')?.touched"
                            style="color: red;margin-left:5px;">
                            Content Type is required
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary custom-btn-add" (click)="onAddTags()"
                    style="margin-right: 10px;">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}} Tag
                </button>
                <button type="button" class="btn btn-secondary custom-btn-cancel" (click)="onCancel()">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-container *ngIf="deployments">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px;">
            <i class="fas fa-home"></i> {{'/'}} Content Configuration {{'/'}} Deployments {{'/'}} View
        </span>

        <div class="table-container">
            <div class="table-header">
                <button class="btn-create" style="font-size: 15px; font-weight: 600;">
                    <span style="cursor:pointer !important"
                        (click)="openAddForm(addDeployment); this.deploymentForm.reset();">
                        <i class="fas fa-plus" style="margin-right: 5px;"></i>
                        <span>Create Deployment</span>
                    </span>
                </button>
            </div>

            <div class="table-controls">
                <span style="margin-top:-5px;">
                    <label for="entries" style="font-size: 15px;">Show</label>
                    <select style="font-size: 15px;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Deployment')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px;">entries</span>
                </span>
                <div class="search-container">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Deployment')"
                            (keypress)="preventSpace($event)" (blur)="validateInput()"
                            placeholder="Search for deployment..." class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'id'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;" (click)="sortData('serviceName', 'Deployments')">Deployment
                            <span style="float: right;" *ngIf="sortColumn === 'serviceName'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('email', 'Deployments')">Key
                            <span style="float: right;" *ngIf="sortColumn === 'email'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- No results found -->
                    <ng-template #noResultsTemplate>
                        <tr>
                            <td colspan="14" class="no-data">
                                <span>No results found</span>
                            </td>
                        </tr>
                    </ng-template>

                    <!-- Check if the filtered deployments list is empty -->
                    <ng-container *ngIf="deploymentsArray?.length === 0; else dataTemplate">
                        <ng-container *ngTemplateOutlet="noResultsTemplate"></ng-container>
                    </ng-container>

                    <!-- Data rows -->
                    <ng-template #dataTemplate>
                        <tr *ngFor="let publisher of deploymentsArray; let i = index">
                            <td style="font-size: 15px; text-align: center;">
                                {{ (currentPage - 1) * pageSize + i + 1 }}
                            </td>
                            <td style="font-size: 15px;text-align: center;word-break: break-all;max-width: 100px;">
                                {{ publisher.serviceName }}
                            </td>
                            <td style="font-size: 15px;text-align: center;">
                                {{ publisher.email ? publisher.email : 'N/A'}}
                            </td>
                            <td style="font-size: 15px; text-align: center;">
                                <span (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Deployments')"
                                    class="action-text delete">
                                    <i class="fa fa-close"></i> Delete
                                </span>
                                <span (click)="openAddForm(addDeployment); EditTag(publisher, 'Deployments')"
                                    class="action-text edit">
                                    <i class="fas fa-pen"></i> Edit
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>


            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px;background-color: white;"
                        (click)="previousPage(deploymentsArray, 'Deployment')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,deploymentsArray, 'Deployment')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button style="margin-left: 10px; margin-right: 10px; font-size: 15px; background-color: white;"
                        (click)="nextPage(deploymentsArray, 'Deployment')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
        <ng-template #addDeployment let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{toBeEditedTagId ? 'Edit' : 'Add'}} Deployment</h5>
                <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="deploymentForm" (ngSubmit)="onSubmitDeployemnts()" style="padding: 20px;">
                    <div class="mb-3">
                        <label for="deploymentName" class="form-label" style="margin-bottom: 7px;">Deployment Name
                            <span> <strong style="color: red;">*</strong> </span>
                        </label>
                        <input (keypress)="preventSpace($event)" maxlength="50" type="text" class="form-control"
                            id="deploymentName" placeholder="Enter Valid Name" formControlName="deploymentName" />
                        <!-- Error Message -->
                        <div
                            *ngIf="deploymentForm.get('deploymentName')?.touched && deploymentForm.get('deploymentName')?.invalid">
                            <span style="color: red;margin-left:5px;"
                                *ngIf="deploymentForm.get('deploymentName')?.hasError('required')">
                                Deployment Name is required.
                            </span>
                            <span style="color: red;margin-left:5px;" *ngIf="!deploymentForm.get('deploymentName')?.hasError('required') && 
                                         deploymentForm.get('deploymentName')?.hasError('invalidCharacters')">
                                Deployment Name should not contain emojis or special characters.
                            </span>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary custom-btn-add" style="margin-right: 10px;"
                    (click)="onSubmitDeployemnts()">
                    {{toBeEditedTagId ? 'Edit' : 'Add'}} Deployment
                </button>
                <button type="button" class="btn btn-secondary custom-btn-cancel"
                    (click)="modal.dismiss('Cancel click')">
                    Cancel
                </button>
            </div>
        </ng-template>

    </ng-container>

    <ng-template #addChangePasswordModal let-modal>
        <div class="modal-dialog">
            <div class="modal-content change-password-container">
                <div class="modal-header">
                    <h5 class="modal-title">Change Password</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body" style="padding: 20px;">
                    <form [formGroup]="passwordForm" (ngSubmit)="chnagePaasword()" style="margin-top: -25px;">
                        <!-- Email Field -->
                        <div class="form-group">
                            <label for="email">Email<span style="color: red;margin-left: 5px;">*</span></label>
                            <input (keypress)="preventSpace($event)"
                                style="width: 459px;margin-top: -12px;margin-bottom: -5px;" type="email" id="email"
                                autocomplete="off" class="form-control" formControlName="email"
                                placeholder="Enter Email" />
                            <div *ngIf="passwordForm.get('email')?.touched && passwordForm.get('email')?.invalid"
                                style="color: red;margin-left:5px;">
                                <span *ngIf="passwordForm.get('email')?.hasError('required')">Email is required.</span>
                                <span *ngIf="passwordForm.get('email')?.hasError('pattern')">Enter a valid email.</span>
                            </div>
                        </div>

                        <!-- Current Password Field -->
                        <div class="form-group">
                            <label for="currentPassword">Current Password<span
                                    style="color: red;margin-left: 5px;">*</span></label>
                            <div class="input-group">
                                <input (keypress)="preventSpace($event)" maxlength="20"
                                    [type]="showCurrentPassword ? 'text' : 'password'" id="currentPassword"
                                    autocomplete="new-password" class="form-control"
                                    style="margin-top: -12px;margin-bottom: -5px;" formControlName="currentPassword"
                                    placeholder="Enter Current Password" />
                                <i class="fa" [ngClass]="showCurrentPassword ? 'fa-eye-slash' : 'fa-eye'"
                                    (click)="togglePasswordVisibilitys('current')"
                                    style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                                </i>
                            </div>
                            <div *ngIf="passwordForm.get('currentPassword')?.touched && passwordForm.get('currentPassword')?.invalid"
                                style="color: red;margin-left:5px;">
                                Current password is required.
                            </div>
                        </div>

                        <!-- New Password Field -->
                        <div class="form-group">
                            <label for="newPassword">New Password<span
                                    style="color: red;margin-left: 5px;">*</span></label>
                            <div class="input-group">
                                <input style="margin-top: -12px;margin-bottom: -5px;" (keypress)="preventSpace($event)"
                                    maxlength="20" [type]="showNewPassword ? 'text' : 'password'"
                                    autocomplete="new-password" id="newPassword" class="form-control"
                                    formControlName="newPassword" placeholder="Enter New Password" />
                                <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"
                                    (click)="togglePasswordVisibilitys('new')"
                                    style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                                </i>
                            </div>
                            <div *ngIf="passwordForm.get('newPassword')?.touched && passwordForm.get('newPassword')?.invalid"
                                style="color: red;margin-left:5px;">
                                <span *ngIf="passwordForm.get('newPassword')?.hasError('required')">
                                    New password is required.
                                </span>
                                <span *ngIf="!passwordForm.get('newPassword')?.hasError('required') && 
                                              passwordForm.get('newPassword')?.hasError('minlength')">
                                    Password must be at least 6 characters long.
                                </span>
                                <span *ngIf="!passwordForm.get('newPassword')?.hasError('required') && 
                                              !passwordForm.get('newPassword')?.hasError('minlength') && 
                                              passwordForm.get('newPassword')?.hasError('maxlength')">
                                    Password must be no more than 20 characters long.
                                </span>
                                <span *ngIf="!passwordForm.get('newPassword')?.hasError('required') && 
                                              !passwordForm.get('newPassword')?.hasError('minlength') && 
                                              !passwordForm.get('newPassword')?.hasError('maxlength') && 
                                              passwordForm.get('newPassword')?.hasError('passwordStrength')">
                                    Password must contain at least one special character, one digit, and one uppercase
                                    letter.
                                </span>
                            </div>
                        </div>

                        <!-- Confirm Password Field -->
                        <div class="form-group" style="margin-bottom: 40px;">
                            <label for="confirmPassword">Confirm Password<span
                                    style="color: red;margin-left: 5px;">*</span></label>
                            <div class="input-group" style="position: relative;">
                                <input style="margin-top: -12px;margin-bottom: -10px;" (keypress)="preventSpace($event)"
                                    maxlength="20" autocomplete="new-password"
                                    [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
                                    class="form-control" formControlName="confirmPassword"
                                    placeholder="Confirm New Password" />
                                <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"
                                    (click)="togglePasswordVisibilitys('confirm')"
                                    style="position: absolute; right: 10px; top: 45%; transform: translateY(-50%); cursor: pointer; z-index: 10;">
                                </i>
                            </div>
                            <div *ngIf="passwordForm.get('confirmPassword')?.touched && passwordForm.get('confirmPassword')?.invalid"
                                style="color: red;margin-left:5px;">
                                Confirm password is required.
                            </div>
                            <div *ngIf="passwordMismatch" style="color: red;margin-left:5px;">
                                Passwords do not match.
                            </div>
                        </div>

                        <!-- Buttons -->
                        <div class="modal-footer" style="margin-top: 20px;padding: 0 !important;">
                            <button type="button" class="btn custom-btn-change-password" style="margin-right:10px"
                                (click)="chnagePaasword()">
                                Change Password
                            </button>
                            <button type="button" class="btn btn-secondary custom-btn-cancel"
                                (click)="modal.dismiss('Cancel click')">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-container *ngIf="conentApproval">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px;">
            <i class="fas fa-home"></i> {{'/'}} Dashboard {{'/'}} Content Approval
        </span>

        <div class="table-container">
            <div class="table-header">
                <button class="btn-create" style="font-size: 15px;color: darkslategray;">
                    Filter Content
                </button>
            </div>
            <div>
                <select disabled style="cursor: not-allowed;" class="search_opt" name="" id="">
                    <option value="1" selected disabled>Select any comapny</option>
                </select>
                <select class="search_opt" name="" id="">
                    <option value="1" selected>Pending Approval</option>
                    <option value="1">Active Content</option>
                    <option value="1">Approved Content</option>
                    <option value="1">Incomplete Content</option>
                    <option value="1">Rejected Content</option>
                    <option value="1">Disabled Content</option>
                </select>
                <select class="search_opt" name="" id="">
                    <option value="1" selected disabled>Select Conetnt Type</option>
                    <option value="1">Music</option>
                </select>
                <select class="search_opt" name="" id="">
                    <option value="1" selected disabled>Select Tags</option>
                </select>
                <input class="search_opt" type="text" style="font-size: 15px;border: 1px solid black;" id="search"
                    placeholder="Search Content by name">
                <button style="font-size: 15px;width: 5vw;border-radius: 5px;" class="n_btn">Search</button>
            </div>
            <div class="table-controls">
                <span>
                    <label for="entries" style="font-size: 15px;">Show</label>
                    <select style="font-size: 15px;" id="entries" [(ngModel)]="pageSize">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px;">entries</span>
                </span>

                <span class="search_table" style="margin-top: -5px;
            /* border: 1px solid black; */
            margin-bottom: 5px;">
                    <label for="search" style="font-size: 15px;">Search:</label>
                    <input type="text" style="font-size: 15px;" id="search" [(ngModel)]="searchTerm"
                        placeholder="Search publishers">
                </span>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <!-- <th style="text-align: center;">S.No</th> -->
                        <th style="text-align: center;"><input type="checkbox"></th>
                        <th style="text-align: center;">Image</th>
                        <th style="text-align: center;">Content Name</th>
                        <th style="text-align: center;">Content Type</th>
                        <!-- <th style="text-align: center;">Type</th> -->
                        <!-- <th style="text-align: center;">Tags</th> -->
                        <!-- <th style="text-align: center;">Deployed On</th> -->
                        <th style="text-align: center;">Status</th>
                        <th style="text-align: center;">Approval</th>
                        <th style="text-align: center;">Options</th>
                        <!-- <th style="text-align: center;">Publisher-Publishers</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let publisher of paginatedPublishers; let i = index">
                        <!-- <td style="font-size: 15px; text-align: center;">{{ (currentPage - 1) * pageSize + i + 1 }}</td> -->
                        <td style="font-size: 15px; text-align: center;"><input type="checkbox" name="" id=""></td>
                        <td style="font-size: 15px;text-align: center;">{{ publisher.image }}</td>
                        <td style="font-size: 15px;text-align: center;">{{ publisher.contentName }}</td>
                        <td style="font-size: 15px;text-align: center;">{{ publisher.contentType }}</td>
                        <!-- <td style="font-size: 15px;text-align: center;">{{ publisher.type }}</td> -->
                        <!-- <td style="font-size: 15px;text-align: center;">{{ publisher.tags }}</td> -->
                        <!-- <td style="font-size: 15px;text-align: center;">{{ publisher.deployedOn }}</td> -->
                        <td style="font-size: 15px;text-align: center;">{{ publisher.status }}</td>
                        <td style="font-size: 15px;text-align: center;">{{ publisher.approval }}</td>
                        <td style="font-size: 15px;text-align: center;">
                            <button style="margin-right: 8px;
                        padding: 5px;
                        border: none;
                        background: none;
                        margin-left: 5px;text-align: center;"><i class="fa fa-close"></i> Delete</button>
                            <button style="margin-right: 8px;
                        padding: 5px;
                        border: none;
                        background: none;
                        margin-left: 5px;text-align: center;"><i class="fas fa-pen"></i> Edit</button>
                        </td>
                        <!-- <td style="font-size: 15px;text-align: center;">{{ 'View' }} <i class="fas fa-share"></i></td> -->
                    </tr>
                </tbody>
            </table>

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px;">Showing 1 to 6 of 6 entries
                    <div style="margin-top: 10px;margin-bottom: 10px;">
                        <button class="n_btn">Select All</button>
                        <button class="n_btn">Unselect All</button>
                        <button class="n_btn">Select Tag</button>
                        <button class="n_btn">Remove Tag</button>
                        <button class="n_btn">Deploy</button>
                        <button class="n_btn">Undeploy</button>
                    </div>
                </span>
                <!-- <span><button style="margin-right: 10px;font-size: 15px;" (click)="previousPage(paginatedPublishers)"
                        [disabled]="currentPage === 1">
                        <i class="fas fa-chevron-left"></i> Previous
                    </button>
                    <span style="font-size: 15px;">Page {{ currentPage }} of {{ totalPages }}</span>
                    <button style="margin-left: 10px; margin-right: 10px;font-size: 15px;"
                        (click)="nextPage(paginatedPublishers)" [disabled]="currentPage === totalPages">
                        Next <i class="fas fa-chevron-right"></i>
                    </button>
                </span> -->
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="openMusicAddForm">
        <div class="music-add-container" style="margin-top: 100px;">
            <h2 style="font-size: 17px;font-weight: 400;"> {{toBeEditedTagId ? 'Edit' : 'Add'}} Music</h2>
            <hr class="section-dividers">
            <form [formGroup]="musicForm" (ngSubmit)="onAddMusic()">

                <!-- Basic Details Section -->
                <div class="section-header">Basic Details</div>
                <hr class="section-divider">
                <div style="display: flex; justify-content: space-between; gap: 20px;">
                    <div class="form-group" style="flex: 1;">
                        <label for="publisher" class="form-label">Publisher<span
                                style="color: red;margin-left:5px">*</span></label>
                        <ng-select formControlName="publisher" [items]="activePublishers" bindLabel="publisherName"
                            placeholder="Select Publisher" id="publisher" class="form-select">
                        </ng-select>
                        <div style="margin-top: -10px;"
                            *ngIf="musicForm.get('publisher').hasError('required') && musicForm.get('publisher').touched">
                            <span style="color: red;margin-left:5px;">Publisher is required.</span>
                        </div>

                        <span
                            *ngIf="musicForm.get('publisher').hasError('required') && !musicForm.get('publisher').touched"
                            style="color: red;margin-left:5px;">
                            {{ errorMessageForPublisher }}
                        </span>

                    </div>

                    <div class="form-group" style="flex: 1;">
                        <label for="tags">Tags<span style="color: red;margin-left:5px">*</span></label>
                        <ng-multiselect-dropdown class="form-select" [placeholder]="'Select Tags'"
                            formControlName="tags" [settings]="tagsSettings" [data]="tagsArray">
                        </ng-multiselect-dropdown>
                        <div style="margin-top: -10px;"
                            *ngIf="musicForm.get('tags').hasError('required') && musicForm.get('tags').touched">
                            <span style="color: red;margin-left:5px;">Tags are required.</span>
                        </div>
                    </div>
                </div>

                <!-- Content Details Section -->
                <div class="section-header">Content Details</div>
                <hr class="section-divider">
                <div class="form-container">
                    <div class="form-group">
                        <label for="name">Name<span style="color: red;margin-left:5px;">*</span></label>
                        <input (keypress)="preventSpace($event)" maxlength="50" type="text" id="name"
                            class="form-control" placeholder="Enter Name" formControlName="name">
                        <div style="margin-top: -20px;"
                            *ngIf="musicForm.get('name')?.touched && musicForm.get('name')?.invalid">
                            <span style="color: red;margin-left:5px;"
                                *ngIf="musicForm.get('name')?.hasError('required')">
                                Name is required.
                            </span>
                            <span style="color: red;margin-left:5px;"
                                *ngIf="!musicForm.get('name')?.hasError('required') && musicForm.get('name')?.hasError('invalidCharacters')">
                                Name should not contain emojis or special characters.
                            </span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="artist">Artist<span style="color: red;margin-left:5px;">*</span></label>
                        <ng-select formControlName="artist" [items]="artistArray" bindLabel="artistName"
                            placeholder="Select Artist" id="artist" class="form-select">
                        </ng-select>
                        <div style="margin-top: -10px;"
                            *ngIf="musicForm.get('artist').hasError('required') && musicForm.get('artist').touched">
                            <span style="color: red;margin-left:5px;">Artist is required.</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="featuredArtist">Featured Artist</label>
                        <ng-select formControlName="featuredArtist" [items]="artistArray" bindLabel="artistName"
                            placeholder="Select Featured Artist" id="featuredArtist" class="form-select">
                        </ng-select>
                    </div>
                </div>

                <div class="form-container">
                    <div class="form-group">
                        <label for="album">Album<span style="color: red;margin-left:5px;">*</span></label>
                        <input formControlName="album" type="text" id="album" class="form-control"
                            placeholder="Enter Album Name">
                        <div style="margin-top: -20px;"
                            *ngIf="musicForm.get('album').hasError('required') && musicForm.get('album').touched">
                            <span style="color: red;margin-left:5px;">Album is required.</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="language">Add/Edit Language<span
                                style="color: red;margin-left:5px;">*</span></label>
                        <ng-select formControlName="language" [items]="languageArray" bindLabel="languageName"
                            placeholder="Select Language" id="language" class="form-select">
                        </ng-select>
                        <div style="margin-top: -10px;"
                            *ngIf="musicForm.get('language').hasError('required') && musicForm.get('language').touched">
                            <span style="color: red;margin-left:5px;">Language is required.</span>
                        </div>
                    </div>
                </div>

                <div class="form-container">
                    <div class="form-group">
                        <label for="shortDescription">Short Description<span
                                style="color: red;margin-left:5px;">*</span></label>
                        <textarea formControlName="shortDescription" id="shortDescription" class="form-control"
                            placeholder="Enter Short Description" maxlength="200"></textarea>
                        <div style="margin-top: -10px;"
                            *ngIf="musicForm.get('shortDescription').hasError('required') && musicForm.get('shortDescription').touched">
                            <span style="color: red;margin-left:5px;">Short Description is required.</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="description">Description</label>
                        <textarea maxlength="500" formControlName="description" id="description" class="form-control"
                            placeholder="Enter Description"></textarea>
                    </div>
                </div>

                <!-- Category Section -->
                <div class="section-header">Genres</div>
                <hr class="section-divider">
                <div style="display: flex; width: 59%; justify-content: space-between;">
                    <div class="form-group">
                        <label for="category" class="form-label">Genre<span
                                style="color: red;margin-left:5px;">*</span></label>
                        <ng-select formControlName="genre" id="genre" class="form-select" style="width: 400px;"
                            [items]="genreArray" bindLabel="categoryName" bindValue="categoryName"
                            placeholder="Select Genre">
                        </ng-select>
                        <div style="margin-top: -10px;"
                            *ngIf="musicForm.get('genre').hasError('required') && musicForm.get('genre').touched">
                            <span style="color: red; margin-left: 5px;">Genre is required.</span>
                        </div>
                    </div>
                </div>

                <!-- CRBT Entry Section -->
                <!-- <div class="section-header">CRBT Entry</div>
                <hr class="section-divider">
                <div class="form-group">
                    <label for="crbtEntry">Search CRBT Entry</label>
                    <input type="text" id="crbtEntry" class="form-control" placeholder="Search existing CRBT Entry">
                </div>
                <div class="note">
                    <p>Note:</p>
                    <ul>
                        <li>This value is just to know if CRBT song exists with some other publisher, this doesn't have
                            any effect on current entry.</li>
                        <li>Make sure you select song if already exists.</li>
                        <li>You still have to upload the CRBT file.</li>
                        <li>Applicable only if you want to upload CRBT file.</li>
                    </ul>
                </div> -->

                <!-- Music File Section -->
                <div class="section-header">Music File</div>
                <hr class="section-divider">

                <div style="display: flex; justify-content: space-between; gap: 15px;">
                    <!-- Music File Upload -->
                    <div class="form-group file-upload" style="flex: 1;">
                        <label for="musicFile" class="form-label">Music File<span
                                style="color: red; margin-left: 5px;">*</span></label>
                        <input style="margin-top: -15px;" type="file" type="file" formControlName="musicFile"
                            id="musicFile" accept=".mp3" (change)="onMusicFileSelected($event)">
                        <span style="font-weight: 600;margin-top: -15px;margin-bottom: 10px;">Upload valid MP3
                            File.</span>
                        <div style="margin-top: -18px;margin-bottom: -21px;"
                            *ngIf="musicForm.get('musicFile').hasError('required') && musicForm.get('musicFile').touched">
                            <span style="color: red; margin-left: 5px;">Music File is required.</span>
                        </div>
                        <div class="drag-drop-area" style="padding: 25px;">
                            <div *ngIf="musicFileUrl">
                                <audio style="height: 70px; padding: 10px; width: 100%;" controls
                                    [src]="!selectedMuiscFile ? 'https://' + musicFileUrl : musicFileUrl"
                                    *ngIf="musicFileUrl">
                                </audio>
                            </div>
                        </div>
                    </div>

                    <!-- CRBT File Upload -->
                    <div class="form-group file-upload" style="flex: 1;">
                        <label for="crbtFile" class="form-label">CRBT File<span
                                style="color: red; margin-left: 5px;">*</span></label>
                        <input style="margin-top: -15px;" type="file" type="file" formControlName="crbtFile"
                            id="crbtFile" accept=".wav" (change)="onAudioFileSelected($event, 'crbt')">
                        <span style="font-weight: 600;margin-top: -15px;margin-bottom: 10px;">Upload valid WAV
                            File.</span>
                        <div style="margin-top: -18px;margin-bottom: -21px;"
                            *ngIf="musicForm.get('crbtFile').hasError('required') && musicForm.get('crbtFile').touched">
                            <span style="color: red; margin-left: 5px;">CRBT File is required.</span>
                        </div>
                        <div class="drag-drop-area" style="padding: 25px;">
                            <div *ngIf="crbtFileUrl">
                                <audio style="height: 70px; padding: 10px; width: 100%;" controls
                                    [src]="!selectedCrbtFile ? 'https://' + crbtFileUrl : crbtFileUrl"
                                    *ngIf="crbtFileUrl">
                                </audio>
                            </div>
                        </div>
                    </div>

                    <!-- IVR File Upload -->
                    <div class="form-group file-upload" style="flex: 1;">
                        <label for="ivrFile" class="form-label">IVR File<span
                                style="color: red; margin-left: 5px;">*</span></label>
                        <input style="margin-top: -15px;" type="file" formControlName="ivrFile" id="ivrFile"
                            accept=".wav" (change)="onAudioFileSelected($event, 'ivr')">
                        <span style="font-weight: 600;margin-top: -15px;margin-bottom: 10px;">Upload valid WAV
                            File.</span>
                        <div style="margin-top: -18px;margin-bottom: -21px;"
                            *ngIf="musicForm.get('ivrFile').hasError('required') && musicForm.get('ivrFile').touched">
                            <span style="color: red; margin-left: 5px;">IVR File is required.</span>
                        </div>
                        <div class="drag-drop-area" style="padding: 25px;">
                            <div *ngIf="ivrFileUrl">
                                <audio style="height: 70px; padding: 10px; width: 100%;" controls
                                    [src]="!selectedIvrFile ? 'https://' + ivrFileUrl : ivrFileUrl" *ngIf="ivrFileUrl">
                                </audio>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- bbeatz-dwnld-staging.stacknize.com/crbt/129/B010000506/2099_airplane-fly-over-01.wav
                bbeatz-dwnld-staging.stacknize.com/crbt/131/B010000514/Nea.wav -->


                <!-- Content Section -->
                <div class="section-header">Content</div>
                <hr class="section-divider">
                <div class="form-group file-upload">
                    <label for="previewImage">Preview Image<span style="color: red;margin-left:5px">*</span></label>
                    <input style="margin-top: -15px;" (change)="previewImageFile($event)" type="file"
                        formControlName="previewImage">
                    <span style="font-weight: 600;margin-top: -15px;margin-bottom: 10px;">Upload a valid PNG, JPG or WEP
                        file.</span>
                    <div style="margin-top: -18px;margin-bottom: -21px;"
                        *ngIf="musicForm.get('previewImage').hasError('required') && musicForm.get('previewImage').touched">
                        <span style="color: red;margin-left:5px;">Image File is required.</span>
                    </div>
                    <div class="drag-drop-area">
                        <img *ngIf="previewImageUrl"
                            [src]="!this.preViewImage ? 'https://' + previewImageUrl : previewImageUrl"
                            alt="Image Preview" style="object-fit: cover;width: 100%;height: 100%;opacity: .7;">
                    </div>
                </div>

                <!-- Price Details Section -->
                <!-- <div class="section-header">Price Details</div>
                <hr class="section-divider">
                <div class="form-group">
                    <label for="eligiblePrice">Eligible Price Details</label>
                    <select id="eligiblePrice" class="form-control">
                        <option value="" disabled selected>Select Price Plan</option>
                        <option value="plan1">Plan 1</option>
                        <option value="plan2">Plan 2</option>
                 
                    </select>
                </div> -->

                <!-- Countries Section -->
                <div class="section-header">Countries</div>
                <hr class="section-divider">
                <div style="display: flex; align-items: center; gap: 20px;">
                    <label style="display: flex; align-items: center; gap: 10px;">
                        <input type="radio" name="countryType" (change)="selectCountry('Eligible')"
                            [checked]="selectedCountries === 'Eligible'" />
                        <span>Eligible Country</span>
                    </label>
                    <label style="display: flex; align-items: center; gap: 10px;">
                        <input type="radio" name="countryType" (change)="selectCountry('Restricted')"
                            [checked]="selectedCountries === 'Restricted'" />
                        <span>Restricted Country</span>
                    </label>
                </div>
                <div style="display: flex; width: 60%; justify-content: space-between; margin-top: 20px;">
                    <div class="form-group" *ngIf="selectedCountries === 'Eligible'">
                        <label for="eligibleCountires">Countries<span
                                style="color: red;margin-left:5px;">*</span></label>
                        <ng-multiselect-dropdown formControlName="eligibleCountires" [placeholder]="'Select Countries'"
                            [ngStyle]="{'position': (selectedCountries === 'Eligible') ? 'relative' : 'initial'}"
                            style="width: 400px;" class="form-select music" [settings]="countrySettings"
                            [data]="countryArray">
                        </ng-multiselect-dropdown>
                        <div *ngIf="musicForm.controls['eligibleCountires'].invalid && musicForm.controls['eligibleCountires'].touched"
                            style="color: red;margin-top: -10px;">
                            Eligible countries are required.
                        </div>
                    </div>
                    <div class="form-group" *ngIf="selectedCountries === 'Restricted'">
                        <label for="restrictedCountries">Countries<span
                                style="color: red;margin-left:5px;">*</span></label>
                        <ng-multiselect-dropdown formControlName="restrictedCountries"
                            [placeholder]="'Select Countries'"
                            [ngStyle]="{'position': (selectedCountries === 'Restricted') ? 'relative' : 'initial'}"
                            style="width: 400px;" class="form-select music" [settings]="countrySettings"
                            [data]="countryArray">
                        </ng-multiselect-dropdown>
                        <div *ngIf="musicForm.controls['restrictedCountries'].invalid && musicForm.controls['restrictedCountries'].touched"
                            style="color: red;margin-top: -10px;">
                            Restricted countries are required.
                        </div>
                    </div>
                </div>

                <!-- DRM Section -->
                <!-- <div class="section-header"> <input type="checkbox" style="position: relative;top: .1em;left: .3em;"
                        id="enforceDrm"><span style="margin-left: 10px;font-size: 15px;font-weight: 400;">Enforce DRM
                        (Digital Rights Management)</span>
                </div> -->
                <!-- <div class="form-group drm-checkbox">
                    <input type="checkbox" id="enforceDrm">
                    <label for="enforceDrm">Enable DRM Protection</label>
                </div> -->

                <!-- Action Buttons -->
                <div class="modal-footer" style="margin-left: -20px; margin-top: 20px;">
                    <button (click)="onAddMusic();" type="button" class="btn btn-primary custom-btn-add"
                        style="margin-right: 10px;">
                        {{toBeEditedTagId ? 'Edit' : 'Add'}} Music
                    </button>
                    <button type="button" class="btn btn-secondary custom-btn-cancel"
                        (click)="this.openMusicAddForm = false; this.music = true;">
                        Cancel
                    </button>
                </div>

            </form>
        </div>
    </ng-container>

    <ng-container *ngIf="music">
        <span style="position: relative; bottom: -7em;left: 1em; font-size: 15px;">
            <i class="fas fa-home"></i> {{'/'}} Content Management {{'/'}} Music List {{'/'}} View
        </span>

        <div class="table-container">
            <div class="table-header"
                style="display: flex; align-items: center; justify-content: space-between; padding: 5px; background-color: #f5f5f5;">
                <span style="display: block;">
                    <span style="display:flex;margin-bottom: 20px;margin-top: 10px;">
                        <button *ngIf="CreateMusicPermissions();" class="btn-create"
                            style="font-size: 15px; font-weight: 600;">
                            <span style="cursor:pointer !important"
                                (click)="openMusicForm();this.errorMessageForPublisher = '';">
                                <i class="fas fa-plus" style="margin-right: 5px;"></i>
                                <span>Add Music</span>
                            </span>
                        </button>
                        <span style="margin-top: 5px;">
                            <span class="custom-link-button"
                                [ngClass]="{ 'active': selectedTab === 'All', 'inactive': selectedTab !== 'All' }"
                                (click)="selectTab('All')">
                                All
                            </span>
                            <span class="custom-link-button"
                                [ngClass]="{ 'active': selectedTab === 'Active', 'inactive': selectedTab !== 'Active' }"
                                (click)="selectTab('Active')">
                                Active
                            </span>
                            <span *ngIf="showUserDropdown()" class="custom-link-button"
                                [ngClass]="{ 'active': selectedTab === 'Pending', 'inactive': selectedTab !== 'Pending' }"
                                (click)="selectTab('Pending')">
                                Approval Pending
                            </span>
                            <span *ngIf="showUserDropdown()" class="custom-link-button"
                                [ngClass]="{ 'active': selectedTab === 'Approved', 'inactive': selectedTab !== 'Approved' }"
                                (click)="selectTab('Approved')">
                                Approved
                            </span>
                        </span>
                    </span>
                    <div class="form-group" *ngIf="showFilteredOptions" style="display: flex; margin-left: 20px;">
                        <form style="display: flex;" [formGroup]="filterForm" (ngSubmit)="onFilterMuisc()">
                            <span>
                                <label for="publisher" class="filter-label">Publisher Name</label>
                                <ng-select style="width: 300px; margin-right: 10px;" formControlName="publisher"
                                    [items]="publisherArray" bindLabel="publisherName" placeholder="Select Publisher"
                                    [searchable]="true" class="form-select">
                                </ng-select>
                            </span>
                            <span>
                                <label for="artist" class="filter-label">Artist</label>
                                <ng-select style="width: 300px; margin-right: 10px;" formControlName="artist"
                                    [items]="artistArray" bindLabel="artistName" placeholder="Select Artist"
                                    [searchable]="true" class="form-select">
                                </ng-select>

                            </span>
                            <span>
                                <label for="album" class="filter-label">Album</label>
                                <input style="height: 45px;" formControlName="album" id="album"
                                    class="form-control filter-input" placeholder="Enter Album Name" type="text" />
                            </span>
                            <span>
                                <button type="submit" class="custom-btn-filter"
                                    style="margin-top: 23px; width: 100px; margin-left: 50px;">
                                    Filter
                                </button>
                            </span>
                            <span>
                                <button type="button" (click)="onResetFilters()" class="custom-btn-reset"
                                    style="margin-top: 23px; width: 125px; margin-left: 10px;">
                                    Reset Filters
                                </button>
                            </span>

                        </form>
                    </div>
                </span>
                <span (click)="this.showFilteredOptions = !this.showFilteredOptions"
                    style="display: inline-flex; align-items: center; cursor: pointer;">
                    <i class="fas fa-filter" style="margin-right: 5px;position: relative;"
                        [ngStyle]="{'top': showFilteredOptions ? '-3.5em' : '-1em'}"></i>
                </span>
            </div>
            <div class="table-controls">
                <span style="margin-top: -5px;">
                    <label for="entries" style="font-size: 15px;">Show</label>
                    <select style="font-size: 15px;" id="entries" [(ngModel)]="recordsPerPage"
                        (change)="updatePageSize($event, 'Music')">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span style="margin-left: 8px;font-size: 15px;">entries</span>
                </span>
                <div class="search-container" style="margin-top: 5px;margin-bottom: -10px;">
                    <label for="search" class="search-label">Search:</label>
                    <div class="search-wrapper">
                        <input type="text" id="search" [(ngModel)]="searchTerm" (input)="applySearch('Music')"
                            (keypress)="preventSpace($event)" (blur)="validateInput()" placeholder="Search for music..."
                            class="search-input" />
                        <i class="fa fa-search search-icon"></i>
                    </div>
                </div>
            </div>

            <table class="publisher-table">
                <thead style="border-bottom: 1px solid black;">
                    <tr>
                        <th style="text-align: center;">S.No
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'id'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;" (click)="sortData('imageUrl', 'Music')"><input
                                [checked]="selectAll" type="checkbox" (change)="onCheckboxChange($event)">
                        </th>
                        <th style="text-align: center;">Image
                            <!-- <span style="float: right;" *ngIf="sortColumn === 'imageUrl'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span> -->
                        </th>
                        <th style="text-align: center;" (click)="sortData('id', 'Music')">Music Id
                            <span style="float: right;" *ngIf="sortColumn === 'id'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('title', 'Music')">Name
                            <span style="float: right;" *ngIf="sortColumn === 'title'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('artist', 'Music')">Artist
                            <span style="float: right;" *ngIf="sortColumn === 'artist'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('type', 'Music')">Type
                        </th>
                        <th style="text-align: center;" (click)="sortData('publisher', 'Music')">Publisher
                            <span style="float: right;" *ngIf="sortColumn === 'publisher'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('album', 'Music')">Album
                            <span style="float: right;" *ngIf="sortColumn === 'album'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('tags', 'Music')">Tags
                            <span style="float: right;" *ngIf="sortColumn === 'tags'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('deployedOn', 'Music')">Deployed On
                            <span style="float: right;" *ngIf="sortColumn === 'deployedOn'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;" (click)="sortData('status', 'Music')">Status
                            <span style="float: right;" *ngIf="sortColumn === 'status'">
                                {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                        </th>
                        <th style="text-align: center;">Options</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="musicArray.length > 0; else noDataTemplate">
                        <tr *ngFor="let publisher of musicArray; let i = index">
                            <td style="font-size: 15px; text-align: center;">{{ (currentPage - 1) * pageSize + i + 1 }}
                            </td>
                            <td style="font-size: 15px; text-align: center;">
                                <input type="checkbox" [(ngModel)]="publisher.checked"
                                    (click)="onIndividualCheck(publisher)" />
                            </td>
                            <td style="font-size: 15px; text-align: center;">
                                <img style="height: 40px; width: 40px; border-radius: 50%;"
                                    [src]="'https://' + publisher.image" alt="">
                            </td>
                            <td style="font-size: 15px; text-align: center;">{{ publisher.id }}</td>
                            <td style="font-size: 15px; text-align: center;">{{ publisher.title }}</td>
                            <td style="font-size: 15px; text-align: center; word-wrap: break-word; max-width: 200px;">
                                <div *ngFor="let artist of publisher.artist">
                                    {{ artist }}
                                </div>
                            </td>
                            <td style="font-size: 15px; text-align: center;">{{ publisher.type }}</td>
                            <td style="font-size: 15px; text-align: center; width: 15%; word-break: break-all;">
                                {{ publisher.publisher }}
                            </td>
                            <td style="font-size: 15px; text-align: center;">{{ publisher.album }}</td>
                            <td style="font-size: 15px; text-align: center; word-wrap: break-word; max-width: 200px;">
                                <div *ngFor="let tags of publisher.tags">
                                    {{ tags }}
                                </div>
                            </td>
                            <td style="font-size: 15px; text-align: center; word-wrap: break-word; max-width: 200px;">
                                <div *ngFor="let deployment of publisher.deployments">
                                    {{ deployment }}
                                </div>
                            </td>
                            <td
                                style="font-size: 15px; text-align: center; white-space: nowrap; padding: 10px; border-top: 1px solid black;">
                                <span style="margin-right: 10px;">{{ publisher.status == 'Approval Pending' ? 'Pending'
                                    : publisher.status }}</span>
                                <ng-container *ngIf="selectedTab === 'Approval Pending' || selectedTab === 'Approved'">
                                    <span *ngIf="publisher.status == 'Approval Pending'">
                                        <button [disabled]="disabledButtons"
                                            (click)="openAddForm(openStatusChangeModal); chnageMuiscStatus('Approve', publisher)"
                                            class="n_btn"
                                            style="background-color: green !important; color: white !important; border-radius: 4px; margin-right: 8px;">
                                            Approve
                                        </button>
                                        <button [disabled]="disabledButtons"
                                            (click)="openAddForm(openStatusChangeModal); chnageMuiscStatus('Reject', publisher)"
                                            class="n_btn"
                                            style="background-color: red !important; color: white !important; border-radius: 4px;">
                                            Reject
                                        </button>
                                    </span>
                                    <span *ngIf="publisher.status == 'Approved'">
                                        <button [disabled]="disabledButtons"
                                            (click)="openAddForm(openStatusChangeModal); chnageMuiscStatus('Deploy', publisher)"
                                            class="n_btn"
                                            style="background-color: green !important; color: white !important; border-radius: 4px; margin-right: 8px;">
                                            Deploy
                                        </button>
                                        <button [disabled]="disabledButtons"
                                            (click)="openAddForm(openStatusChangeModal); chnageMuiscStatus('Reject', publisher)"
                                            class="n_btn"
                                            style="background-color: red !important; color: white !important; border-radius: 4px;">
                                            Reject
                                        </button>
                                    </span>
                                </ng-container>
                            </td>
                            <td
                                style="font-size: 15px; text-align: center; white-space: nowrap !important; color: #007bff !important; font-weight: bold !important;">
                                <span *ngIf="showUserDropdown()"
                                    (click)="openAddForm(addDeleteModal); deleteModel(publisher, 'Muisc')"
                                    class="action-text delete">
                                    <i class="fa fa-close"></i> Delete
                                </span>
                                <span *ngIf="CreateMusicPermissions()"
                                    (click)="this.music=false; this.openMusicAddForm = true; EditTag(publisher, 'Muisc')"
                                    class="action-text edit">
                                    <i class="fas fa-pen"></i> Edit
                                </span>
                                <span (click)="fetchMusicDetails(publisher)" class="action-text fetch">
                                    <i class="fas fa-download"></i> Fetch
                                </span>
                            </td>
                        </tr>
                    </ng-container>

                    <!-- No results found template -->
                    <ng-template #noDataTemplate>
                        <tr>
                            <td colspan="14" class="no-data">
                                <span>No results found.</span>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>

            <!-- <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px;">Showing 1 to 6 of 6 entries
                    <div style="margin-top: 10px;margin-bottom: 10px;">
                        <button class="n_btn">Select All</button>
                        <button class="n_btn">Unselect</button>
                        <button class="n_btn">Select Tag</button>
                        <button class="n_btn">Remove Tag</button>
                        <button class="n_btn">Deploy</button>
                        <button class="n_btn">Undeploy</button>
                    </div>
                </span>
                <span><button style="margin-right: 10px;font-size: 15px;" (click)="previousPage(paginatedPublishers)"
                        [disabled]="currentPage === 1">
                        <i class="fas fa-chevron-left"></i> Previous
                    </button>
                    <span style="font-size: 15px;">Page {{ currentPage }} of {{ totalPages }}</span>
                    <button style="margin-left: 10px; margin-right: 10px;font-size: 15px;" (click)="nextPage(paginatedPublishers)"
                        [disabled]="currentPage === totalPages">
                        Next <i class="fas fa-chevron-right"></i>
                    </button>
                </span>
            </div> -->

            <div class="pagination-controls">
                <span style="margin-left: 10px; font-size: 15px;">
                    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
                    <div style="margin-top: 10px; margin-bottom: 10px;">
                        <button class="n_btn" (click)="selectAllRecords()">Select All</button>
                        <button class="n_btn" (click)="unselectAllRecords()">Unselect All</button>
                        <button class="n_btn"
                            (click)="SelectTag(openTagModel, 'Add'); this.tagsListingForm.reset();">Add Tag</button>
                        <button class="n_btn"
                            (click)="RemoveTag(openTagModel, 'Remove');this.tagsListingForm.reset();">Remove
                            Tag</button>
                    </div>
                </span>

                <span>
                    <!-- Previous Button -->
                    <button style="margin-right: 10px; font-size: 15px;background-color: white;"
                        (click)="previousPage(musicArray, 'Music')" [disabled]="currentPage === 1">
                        Previous
                    </button>

                    <!-- Page Numbers -->
                    <ng-container *ngFor="let page of pages">
                        <button *ngIf="page !== '...'" (click)="goToPage(page,musicArray, 'Music')"
                            [disabled]="page === currentPage" [ngStyle]="{
                                'font-size': '15px',
                                'margin': '0 5px',
                                'background-color': currentPage === page ? '#007bff' : '',
                                'color': currentPage === page ? '#fff' : ''
                              }">
                            {{ page }}
                        </button>
                        <span *ngIf="page === '...'">...</span>
                    </ng-container>

                    <!-- Next Button -->
                    <button style="margin-left: 10px; margin-right: 10px; font-size: 15px; background-color: white;"
                        (click)="nextPage(musicArray, 'Music')" [disabled]="currentPage === totalPages">
                        Next
                    </button>
                </span>
            </div>
        </div>
    </ng-container>

    <ng-template #addDeleteModal let-modal>
        <div class="modal-dialog">
            <div class="modal-content change-password-container">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm Delete</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body" style="padding: 20px;width:100vw; word-break:break-all;">
                    <p style="margin-top: 5px;">Are you sure you want to delete the {{(toBeDeletedText == 'Muisc')?
                        'Music' : toBeDeletedText }} ?</p>
                </div>
                <div class="modal-footer" style="margin-top: 0px;">
                    <button class="btn btn-primary custom-btn-add" style="margin-right: 10px;"
                        (click)="deleteFunc()">Delete</button>
                    <button class="btn btn-secondary custom-btn-cancel"
                        (click)="modal.dismiss('Cross click')">Cancel</button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #openStatusChangeModal let-modal>
        <div class="modal-dialog">
            <div class="modal-content change-password-container">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm {{statusChangeText}}</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body" style="padding: 20px;height: 15vh;width:100vw; word-break:break-all;">
                    <p style="margin-top: 5px;">Are you sure you want to {{statusChangeText}} the Record ?</p>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary custom-btn-add" style="margin-right: 10px;"
                        (click)="onMuiscStatusChange()">
                        {{ statusChangeText || 'Action' }}
                    </button>
                    <button class="btn btn-secondary custom-btn-cancel"
                        (click)="modal.dismiss('Cross click')">Cancel</button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #openLogOutModel let-modal>
        <div class="modal-dialog">
            <div class="modal-content change-password-container">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm {{statusChangeText}}</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body" style="padding: 20px;height: 15vh;width:100vw; word-break:break-all;">
                    <p style="margin-top: 15px; margin-left:5px">Are you sure you want to logout ?</p>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success custom-btn-logout" (click)="logout()">
                        Logout
                    </button>
                    <button class="btn btn-secondary custom-btn-cancel"
                        (click)="modal.dismiss('Cross click')">Cancel</button>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #openTagModel let-modal>
        <div class="modal-dialog">
            <div class="modal-content change-password-container">
                <div class="modal-header">
                    <h5 class="modal-title">{{selectedTax}} Tag</h5>
                    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body" style="padding: 20px;margin-top: -20px;width:100vw; word-break:break-all;">
                    <div class="form-group">
                        <form [formGroup]="tagsListingForm"
                            (ngSubmit)="onUpdateTagsStatus(selectedTax === 'Remove' ? true : false)">
                            <label for="tags">Tags <span style="color: red;margin-left:5px;">*</span></label>
                            <ng-multiselect-dropdown style="width: 400px;" formControlName="tags"
                                class="form-select music" [placeholder]="'Select Tags'" [settings]="tagsSettings"
                                [data]="tagsArray">
                            </ng-multiselect-dropdown>
                            <div
                                *ngIf="tagsListingForm.get('tags').hasError('required') && tagsListingForm.get('tags').touched">
                                <span style="color: red;margin-left:5px;">Tags are required.</span>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal-footer">
                    <!-- Dynamic Action Button -->
                    <button
                        [ngClass]="selectedTax === 'Remove' ? 'btn btn-primary custom-btn-add' : 'btn btn-primary custom-btn-add'"
                        (click)="onUpdateTagsStatus(selectedTax === 'Remove' ? true : false)"
                        style="margin-right:10px;">
                        {{ selectedTax + ' ' + 'Tags'}}
                    </button>
                    <!-- Cancel Button -->
                    <button class="btn btn-secondary custom-btn-cancel" (click)="modal.dismiss('Cross click')">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </ng-template>

</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>